export interface LinkData {
    valor: string | number
    nomeTitular: string
    cnpjPagador: string
    email: string
    telefone: string
    nomeLink: string
    dataLiquidacao: string
    quantParcelas: string | number
    frequenciaCobranca: string | number
    observacao: string
    tipoLink: number
    dataLiquidacaoFinal: string
    porcentagemSobreAgenda: string | number
}

export interface InputsFormStep1 {
    nomeTitular: string
    cnpjPagador: string
    email: string
    telefone: string
    observacao: string
    nomeLink: string
    valor: string | number
}

export interface InputsFormStep2 {
    tipoLink: number
    quantParcelas: string | number
    frequenciaCobranca: string | number
    dataLiquidacao: string
    dataLiquidacaoFinal: string
    porcentagemSobreAgenda: string | number
}

export interface Inputs {
    cnpjPagador: string
    // tipoLink: string | number
    // tipoCobranca: string | number
    quantParcelas: string | number
    dataLiquidacao: string
    // contatoData: any
    observacao: string
    nomeTitular: string
    email: string
    telefone: string
}

export interface InitialContactProtocol {
    nomeTitular: string
    cnpjPagador: string
    email: string
    telefone: string
    id: undefined | string | number
}

export const initialContact: InitialContactProtocol = {
    nomeTitular: '',
    cnpjPagador: '',
    email: '',
    telefone: '',
    id: undefined,
}

export interface NomePagadorInput {
    agencia: string
    compe: string
    email: string
    id: string
    ispb: string
    nomeTitular: string
    numeroConta: string
    numeroDocumentoTitular: string
    telefone: string
    tipoConta: string
}

export const NomePagadorInputInitial: NomePagadorInput = {
    agencia: '',
    compe: '',
    email: '',
    id: '',
    ispb: '',
    nomeTitular: '',
    numeroConta: '',
    numeroDocumentoTitular: '',
    telefone: '',
    tipoConta: '',
}
